<signup-form
  (signUp)="signUp($event)"
  (checkEmailOMobileExists)="checkEmailOMobileExists($event)"
  (navigateToPage)="navigateToPage($event)"
  [isEmailExists]="isEmailExists"
  [isMobileExists]="isMobileExists"
  [loading]="loading"
  [formData]="formData"
  [appName]="appName"
></signup-form>